const yodaCoreComponents = {
    Icon: {
        importFn: () => import('yodaCoreComponents/Icon'),
        path: 'yodaCoreComponents/Icon',
        type: 'class',
        isSSR: true,
    },
    CheckBox: {
        importFn: () => import('yodaCoreComponents/CheckBox'),
        path: 'yodaCoreComponents/CheckBox',
        type: 'class',
        isSSR: false,
    },
    MessageBox: {
        importFn: () => import('yodaCoreComponents/MessageBox'),
        path: 'yodaCoreComponents/MessageBox',
        type: 'class',
        isSSR: false,
    },
    ModalBox: {
        importFn: () => import('yodaCoreComponents/ModalBox'),
        path: 'yodaCoreComponents/ModalBox',
        type: 'class',
        isSSR: false,
    },
};

module.exports = { yodaCoreComponents };
